import tubesTables from './tubes_tables';

const tubes = [
  {
    id: "profiles-speciaux",
    title: "Profilés spéciaux",
    image: "/assets/images/products/Profilés spéciaux.webp",
    specImage: "Tubes Profilés spéciaux.webp",
    description: "Tubes et profilés de sections spéciales pour besoins spécifiques",
    longDescription: "Notre gamme de profilés spéciaux comprend diverses sections non standards répondant à des besoins techniques ou esthétiques particuliers. Ces produits sont utilisés dans des applications nécessitant des caractéristiques mécaniques spécifiques ou un design unique, comme l'industrie automobile, le mobilier design ou les structures architecturales.",
    category: "tubes",
    specifications: [
      "Sections variées selon les besoins",
      "Épaisseurs adaptées à l'application",
      "Aciers standards ou spéciaux selon besoin",
      "Finitions diverses disponibles",
      "Possibilité de développement sur mesure"
    ]
  },
  {
    id: "tube-carre",
    title: "Tube carré",
    image: "/assets/images/products/Tube carré.webp",
    specImage: "Tube carré.webp",
    description: "Tubes en acier de section carrée pour structures et constructions",
    longDescription: "Disponibles en différentes épaisseurs de 0.7mm à 8mm.",
    category: "tubes",
    specifications: [
      "Dimensions: de 10x10mm à 300x300mm",
      "Épaisseur: de 1mm à 8mm selon dimensions",
      "Acier S235JRH ou S355J2H",
      "Finition: brute ou galvanisée",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "tube-ovale",
    title: "Tube ovale",
    image: "/assets/images/products/Tube ovale.webp",
    specImage: null,
    description: "Tubes en acier de section ovale pour applications spécifiques",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de tubes ovales.",
    category: "tubes",
    specifications: [
      "Dimensions: plusieurs tailles standards disponibles",
      "Épaisseur: de 1mm à 3mm",
      "Acier S235JRH",
      "Finition: brute ou chromée",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "tube-rectangulaire",
    title: "Tube rectangulaire",
    image: "/assets/images/products/Tube rectangulaire.webp",
    specImage: "Tube rectangulaire.webp",
    description: "Tubes en acier de section rectangulaire pour structures optimisées",
    longDescription: "Disponibles en différentes épaisseurs de 0.7mm à 6mm.",
    category: "tubes",
    specifications: [
      "Dimensions: de 20x10mm à 400x200mm",
      "Épaisseur: de 1mm à 8mm selon dimensions",
      "Acier S235JRH ou S355J2H",
      "Finition: brute ou galvanisée",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "tube-rond",
    title: "Tube rond",
    image: "/assets/images/products/Tube rond.webp",
    specImage: "Tube rond.webp",
    description: "Tubes en acier de section circulaire pour diverses applications",
    longDescription: "Disponibles en différentes épaisseurs de 0.7mm à 8mm.",
    category: "tubes",
    specifications: [
      "Diamètres: de 12mm à 400mm",
      "Épaisseur: de 1mm à 10mm selon dimensions",
      "Acier S235JRH ou S355J2H",
      "Finition: brute ou galvanisée",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "tube-semi-ovale",
    title: "Tube semi-ovale",
    image: "/assets/images/products/Tube semi-ovale.webp",
    specImage: null,
    description: "Tubes en acier de section semi-ovale pour applications spécifiques",
    longDescription: "Disponibles en différentes épaisseurs de 0.7mm à 8mm.",
    category: "tubes",
    specifications: [
      "Dimensions: plusieurs tailles standards disponibles",
      "Épaisseur: de 1mm à 2.5mm",
      "Acier S235JRH",
      "Finition: brute ou chromée",
      "Longueur standard: 6m"
    ]
  },
  {
    id: "tube-galvanise-soude",
    title: "Tube galvanisé soudé",
    image: "/assets/images/products/tubes/tube-galvanise-soude.webp",
    specImage: null,
    description: "Tubes ronds soudés galvanisés à chaud, livrés filetés avec manchon",
    longDescription: "Fabriqués selon la norme ISO 65 et galvanisés à chaud selon la norme EN 10240, ces tubes sont livrés filetés avec un manchon et contrôlés par essais non destructifs. Ils sont utilisés dans le bâtiment, la protection incendie, les systèmes de chauffage, les serres et les projets d'arrosage.",
    category: "tubes",
    specifications: [
      "Norme de fabrication: ISO 65",
      "Galvanisation à chaud: EN 10240",
      "Diamètres: de DN15 (1/2\") à DN100 (4\")",
      "Épaisseur: de 1,9mm à 3,2mm selon diamètre",
      "Livraison: bout fileté avec manchon",
      "Longueur: de 4,90m à 7,20m selon la demande"
    ],
    tables: tubesTables["tube-galvanise-soude"]
  },
  {
    id: "tube-galvanise-sans-soudure",
    title: "Tube galvanisé sans soudure",
    image: "/assets/images/products/tubes/tube-galvanise-sans-soudure.webp",
    specImage: null,
    description: "Tubes sans soudure galvanisés à chaud pour réseaux d'eau et protection incendie",
    longDescription: "Galvanisés par immersion à chaud selon la norme NF EN 10240 niveau A.1, avec un zinc électrolytique pur à 99,995 % et sans plomb, ces tubes sans soudure sont destinés aux réseaux de transport d'eau, aux colonnes sèches et aux installations de robinets d'incendie armés (RIA).",
    category: "tubes",
    specifications: [
      "Galvanisation à chaud: NF EN 10240 niveau A.1",
      "Zinc électrolytique pur à 99,995%, sans plomb",
      "Diamètres: de DN15 (1/2\") à DN100 (4\")",
      "Épaisseur: de 2,3mm à 3,6mm selon diamètre",
      "Applications: réseaux d'eau, colonnes sèches, RIA"
    ],
    tables: tubesTables["tube-galvanise-sans-soudure"]
  },
  {
    id: "tube-noir-sans-soudure",
    title: "Tube noir sans soudure",
    image: "/assets/images/products/tubes/tube-noir-sans-soudure.webp",
    specImage: null,
    description: "Tubes en acier noir sans soudure, tarif 10 et tarif 3, pour fluides sous pression",
    longDescription: "Laminés à chaud et sans soudure, ces tubes en acier noir sont proposés en deux séries. Le tarif 10 (EN 10216-1, acier P235 TR1) est un tube lisse pour le transport de vapeur, de gaz, d'air comprimé et d'eau surchauffée jusqu'à 300 °C. Le tarif 3 (EN 10255, acier S195) est un tube filetable pour les mêmes usages jusqu'à 110 °C.",
    category: "tubes",
    specifications: [
      "Tarif 10: EN 10216-1, acier P235 TR1, de -10°C à 300°C, épreuve 70 bar",
      "Tarif 10: diamètres extérieurs de 21,3mm à 610mm",
      "Tarif 3: EN 10255, acier S195, de -10°C à 110°C, épreuve 50 bar, PN25",
      "Tarif 3: de DN15 (1/2\") à DN100 (4\"), filetable",
      "Applications: vapeur, gaz, air comprimé, eau surchauffée"
    ],
    tables: tubesTables["tube-noir-sans-soudure"]
  },
  {
    id: "tube-chaudiere",
    title: "Tube chaudière",
    image: "/assets/images/products/tubes/tube-chaudiere.webp",
    specImage: null,
    description: "Tubes sans soudure pour chaudières et service sous pression à haute température",
    longDescription: "Conformes à la norme EN 10216-2, en acier P235GH (St 35.8 I), ces tubes supportent des températures de service jusqu'à 600 °C. Ils sont utilisés pour les installations sous pression à haute température et la fabrication de serpentins de chaudières.",
    category: "tubes",
    specifications: [
      "Norme: EN 10216-2",
      "Grade acier: P235GH / St 35.8 I",
      "Température de service: jusqu'à 600°C",
      "Pression d'épreuve: 70 bar",
      "Diamètres: de DN40 (1\"1/2) à DN65 (2\"1/2)",
      "Épaisseur: de 2,9mm à 3,6mm"
    ],
    tables: tubesTables["tube-chaudiere"]
  }
];

export default tubes;
